import React, { PureComponent } from 'react';

import ModalContainer from '../../../../components/shared/modal/ModalContainer';
import { PrimaryButton, StyledRow, SecundaryButton } from '../../../../components/shared/sharedStyles.styles';
import { Container, SpanTitle, GrayText } from '../form/fieldModal/formModalFields.styled';

class ReinclusionModal extends PureComponent {

  renderFooter = () => (
    <StyledRow padding='0 3em' justify="space-around">
      <PrimaryButton data-testid="go-back-button" onClick={this.props.onClose} >CANCELAR</PrimaryButton>
      <SecundaryButton data-testid="send-data-button" onClick={this.props.reinclude}>RECONSULTAR</SecundaryButton>
    </StyledRow>
  )

  renderHeader = () => (
    <SpanTitle customstyle="margin: auto;">
      RECONSULTAR
    </SpanTitle>
  )

  render() {
    return (
      <ModalContainer
        isOpen={this.props.isOpen}
        size="md"
        onClose={this.props.onClose}
        footer={this.renderFooter()}
        header={this.renderHeader()}
        customstyle='
          @media (max-width: 800px) {
            h5 {
              font-weight: 400;
            }
          }
        '
        customstyleModalFooter='
          @media (max-width: 800px) {
            button {
              width: 121px;
              height: 33px;
              font-size: .88rem;
              background-color: #152b4e;
              padding: 0;
              margin-top: 0;
              margin: 0 9px;
            }

            .row {
              justify-content: center;
              padding: 0;
            }
          }
        '
      >

        <Container
          customstyle="
            text-align: center;
            margin: 20px auto;

            @media (max-width: 800px) {
              margin: 10px auto;

              span {
                font-size: 12px;
                font-weight: 400 !important;
              }
            }
          "
        >
          <GrayText>
            Ao clicar em Reconsultar você estará solicitando nova pesquisa deste pretendente, que será cobrada novamente.
          </GrayText>
        </Container>

      </ModalContainer>
    );
  }
}

export default ReinclusionModal;
